<template>
  <section class="milestone container--Medium smallSectionMargins">
    <h2 v-text="data.title" />

    <div class="milestone__Grid">
      <div v-for="item in data.items" class="milestone__Item">
        <h3 v-text="item.title" />
        <div v-html="item.description" />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_milestone.scss');
</style>